<div *ngIf="gaugeObject?.error" class="subtitle-1 text-center text-danger w-100 pt-3">{{ gaugeObject.error }}</div>
<div [hidden]="gaugeObject?.error || isNoMetric || isDateRangeTooWideIntraday || noData" class="gauge-container lato-regular h-100 w-100" #gaugeContainer></div>
<!-- Error Views -->
<app-module-error *ngIf="noData" [noData]="true"></app-module-error>  
<app-module-error *ngIf="isNoMetric" [noMetric]="true"></app-module-error>
<app-module-error *ngIf="isDateRangeTooWideIntraday" [dateRangeTooWideIntraday]="true"></app-module-error>
